import { Tag, Text } from '@wework/dieter-ui'
import React from 'react'
import Row from '../Common/Row'
import { format, parseISO } from 'date-fns'

import DownloadButton from './DownloadButton'

const DATE_FORMAT = {
  DATE: 'yyyy-MM-dd',
}

export default function PlanUnit({ plan, buildingData, extension }) {
  return (
    <Row style={{ marginTop: 24 }}>
      <div
        style={{
          flexDirection: 'column',
          display: 'flex',
          justifyContent: 'space-between',
        }}
      >
        <Text>{plan.name}</Text>
        {plan.last_updated && (
          <Text secondary size="small">
            {format(parseISO(plan.last_updated), DATE_FORMAT.DATE)}
          </Text>
        )}
        <Tag
          style={{
            backgroundColor: extension === 'PDF' ? '#FDE5FF' : '#E5FFFD',
            color: extension === 'PDF' ? '#5E0066' : '#00665D',
            width: 'fit-content',
          }}
        >
          {extension}
        </Tag>
      </div>
      <DownloadButton
        {...plan}
        buildingName={buildingData?.name}
        extension={extension}
      />
    </Row>
  )
}
